import { connect } from 'react-redux';
import PortalTemplate from './PortalTemplate';
import { portalTemplateSelector, portalModalSelector } from 'Store/selectors';
import { nullSafe } from 'Utility/globalMethods';

const mapStateToProps = (state) => ({
  withNavigation: nullSafe(() => portalTemplateSelector(state).withNavigation),
  flowPopupId: nullSafe(() => portalModalSelector(state).flowPopup),
  showFooter: nullSafe(() => portalTemplateSelector(state).showFooter),
  pageTitle: nullSafe(() => portalTemplateSelector(state).pageTitle),
  goBackLabel: nullSafe(() => portalTemplateSelector(state).goBackLabel),
  goToRoute: nullSafe(() => portalTemplateSelector(state).goBackRoute),
  customGoBackOnClick: nullSafe(() => portalTemplateSelector(state).customGoBackOnClick, null),
  hasLightBackground: nullSafe(() => portalTemplateSelector(state).hasLightBackground),
  hasLogo: nullSafe(() => portalTemplateSelector(state).hasLogo),
});

export default connect(mapStateToProps, null, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  actions: dispatchProps,
}))(PortalTemplate);
